export default __webpack_public_path__ + "static/media/title_image.75a7d837.png";